import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, auth } from "../api";

export default function Login() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError(""); setBusy(true);
    try {
      const { token } = await api("/auth/login", { method: "POST", body: { email, password } });
      auth.set(token);
      nav("/", { replace: true });
    } catch (err) { setError(err.message); }
    finally { setBusy(false); }
  }

  return (
    <div className="login-wrap">
      <form className="card card-pad login-card" onSubmit={submit}>
        <div className="wordmark">Predict<span className="dot">y</span></div>
        <p className="muted" style={{ marginTop: 4, marginBottom: 22 }}>
          Paris Polymarket pilotés par agents IA
        </p>
        <label className="field" style={{ textAlign: "left" }}>
          <span>Email</span>
          <input className="input" type="email" value={email}
            onChange={(e) => setEmail(e.target.value)} autoComplete="username" />
        </label>
        <label className="field" style={{ textAlign: "left" }}>
          <span>Mot de passe</span>
          <input className="input" type="password" value={password}
            onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" />
        </label>
        {error && <p className="error" style={{ marginBottom: 12 }}>{error}</p>}
        <button className="btn btn-accent btn-block btn-lg" type="submit" disabled={busy}>
          {busy ? "Connexion…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
